export default __webpack_public_path__ + "static/146-4fc64bebb890700ba6a2fe399f0c6ca9.jpg";